import React from "react";
import { Link } from "react-router-dom";

function MercyChaplet() {
  return (
    <div>
      <Link to="/mercychaplet/terms">
        <div>Terms and Conditions</div>
      </Link>
      <Link to="/mercychaplet/policy">
        <div>Privacy Policy</div>
      </Link>
    </div>
  );
}

export default MercyChaplet;
